import React from 'react';

import useGetInitialData from '@/useGetInitialData';
import InitialSpinner from '@/components/common/InitialSpinner/InitialSpinner';

interface IInitialDataLoaderProps {
  children: any;
}

export default function InitialDataLoader({ children }: IInitialDataLoaderProps) {
  const { initialData, isLoading, error, isApiCalled } = useGetInitialData();

  if (isLoading) {
    return (
      <InitialSpinner />
    );
  }

  if (isApiCalled && !initialData) {
    return (
      <div className="d-flex justify-content-center ">
        An error occurred while loading the initial data<br />

        {error && (
          error.message
        )}
      </div>
    );
  }

  if (!initialData) {
    return <></>;
  }

  return children;
}
